import { EventFilterPropertyNames } from "../../../features/Library/Events/types/state";
import { type FilterItemBase } from "../FilterFormBuilder/FilterFormBuilder";
import { FilterViewTypes } from "../../../enums/filterViewTypes";

export const getEventFilters = (includePublisher: boolean = true): FilterItemBase<EventFilterPropertyNames>[] => {
  let filters: FilterItemBase<EventFilterPropertyNames>[] = [
    {
      type: FilterViewTypes.DateRange,
      label: "Date Added",
      propertyName: EventFilterPropertyNames.DateCreated,
    },
    {
      type: FilterViewTypes.DateRange,
      label: "Last Modified",
      propertyName: EventFilterPropertyNames.DateModified,
    },
  ];

  if (includePublisher) {
    filters.push({
      type: FilterViewTypes.MultiSelect,
      label: "Publisher",
      propertyName: EventFilterPropertyNames.Publishers,
      placeholder: "All Publishers",
    });
  }

  filters.push(
    {
      type: FilterViewTypes.MultiSelect,
      label: "Packs",
      propertyName: EventFilterPropertyNames.Packs,
      placeholder: "All Packs",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Software Applications",
      propertyName: EventFilterPropertyNames.SoftwareApplications,
      placeholder: "All Applications",
    },
    {
      type: FilterViewTypes.MultiSelect,
      label: "Labels",
      propertyName: EventFilterPropertyNames.Labels,
      placeholder: "All Labels",
    },
    {
      type: FilterViewTypes.Select,
      label: "Visibility",
      propertyName: EventFilterPropertyNames.Visibility,
      placeholder: "All Visibility",
    },
  );

  return filters;
};
